import { render, staticRenderFns } from "./MainNotifications.vue?vue&type=template&id=95446a4a&"
import script from "./MainNotifications.vue?vue&type=script&lang=js&"
export * from "./MainNotifications.vue?vue&type=script&lang=js&"
import style0 from "./MainNotifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports